import { Scrollbars } from 'react-custom-scrollbars';

require("utility/select_options.scss");

var SelectOptions = function(props) {
	var options = props.options;
	if (props.value) {
		var lowerCaseValue = props.value.toString().toLowerCase().trim();
		options = _.select(options, function(option) {
			var optionValue = option.label.toString().toLowerCase().trim();

			if (props.hideFullMatch && (lowerCaseValue == optionValue)) {
				return false;
			}
			return optionValue.indexOf(lowerCaseValue) > -1;
		});
	}

	var selectContents = [];
	var currentGroup = undefined;
	var currentSubGroup = undefined;

	_.each(options, function(option, index) {
		if (props.onSelect) {
			var selectF = function(e) {
				$wr.nope(e)
				props.onSelect(option)
			}
		}

		if (currentSubGroup != option.subgroup) {
			selectContents.push(
				<div key={ "divider-" + option.subgroup + "-" + index } className="subDivider" />
			);
			currentSubGroup = option.subgroup;
		}

		if (option.color) {
			var colorDot = (
				<span className="colorDot" style={ { backgroundColor: option.color } } />
			)
		}

		selectContents.push(
			<div className="selectOp" key={ option.value } onMouseDown={ selectF }>
				{ colorDot } { option.label }
			</div>
		);
	});

	var className = "selectOptions ";
	if (options.length > 0) {
		className += "present";
	}

	return (
		<div className={ className }>
			<div className="selectInner">
				<Scrollbars autoHeight autoHeightMin={ 0 } autoHeightMax={ 200 }>
					{ selectContents }
				</Scrollbars>
			</div>
		</div>
	);
};

SelectOptions.propTypes = StrictPropTypes({
	// list of { label: "A and B and C", value: "abc" }
	options: PropTypes.array.isRequired, 

	value: PropTypes.string,

	onSelect: PropTypes.func,

	// If true, it won't show perfect matches
	hideFullMatch: PropTypes.bool
});

module.exports = SelectOptions;



// WEBPACK FOOTER //
// ./modules/components/utility/SelectOptions.js